<!-- 回到顶部组件 -->
<template>
    <div class="scroll_top" v-bind:class="{showscrollTop : fixedHeader}">
    <div class="marquee-box" v-if="leftTitle!=null" style="text-align:right;color: #0071FF;padding-left: 40px;font-size: 16px;">{{leftTitle}}</div>
      <img :class="trumpet==true ? 'img1' : 'img'"
           src="../../assets/img/25.png">
        <div class="marquee-box" style="width:100%;padding-left:1%;">
            <div class="marquee-content" ref="out">
                <p :class="run?speed:''" :style="{'--speed': speedStyle}" >
                    <span class="text1" ref="in"  v-html="content"></span>
                    <span class="text2" v-if="showtwo||run" v-html="content"></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	data (){
        return{
            run: false,
            fixedHeader:false,
            speedStyle:"20s",
        }
    },
	mounted() {
        var _this = this;
        this.$nextTick(()=>{
            let out = _this.$refs.out.clientWidth;
            let _in = _this.$refs.in.clientWidth;
            _this.speedStyle=_in/80+"s"
            _this.run=_in>out?true:false;
        });
    },
	methods:{
	},
    watch:{
        'content':function(e){
            var _this = this;
            _this.$nextTick(()=>{
            let out = _this.$refs.out.clientWidth;
            let _in = _this.$refs.in.clientWidth;
            _this.speedStyle=_in/80+"s"
            _this.run=_in>out?true:false;
        });
        }
    },
    props: {
        speed: {
            default: 'middle',
            type: String
        },
        showtwo: {
            default: false
        },
        content: {
            type: String,
            default: ""
        },
        leftTitle:{
            type: String,
            default:null
        },
        trumpet:{
          type:Boolean,
          default:false
        }
    }
}
</script>

<style scoped>
.img {
  position: relative;
  left: -65px;
  top:8px;
  border: 1px #ff00ff;
}
.img1 {
  position: relative;
  left: -69px;
  top:8px;
  border: 1px #ff00ff;
}
.scroll_top {
	opacity: 1;
    display: block;
    overflow: hidden;
    z-index: 20000;
    width: 100%;
    line-height: 50px;
    white-space: nowrap;
}
.marquee-box {
 height: 50px;
 line-height: 50px;
 display: inline-block;
 vertical-align:middle;
 font-weight:666;
 }
 .marquee-content{
 overflow: hidden;
 }
 .marquee-content p{
 display: inline-block;
 white-space: nowrap;
 margin: 0;
 }
 .marquee-content span{
 display: inline-block;
 white-space: nowrap;
line-height: 50px;
 padding-right: 100px;
 font-size: 14px;
font-weight:100;
 }
 .middle{
 -webkit-animation: marquee var(--speed) linear infinite;
 animation: marquee var(--speed) linear infinite;
 }
 @-webkit-keyframes marquee {
 0% { -webkit-transform: translate3d(0,0,0); }
 100% { -webkit-transform: translate3d(-50%,0,0); }
 }
 @keyframes marquee {
 0% { transform: translateX(0); }
 100% { transform: translateX(-50%);}
 }
</style>
